<div class="row m-0">
    <div class="tmplt-list-title col-xs-12 mt-3">
        <h2 translate="{{title}}" class="f-24"></h2>
    </div>
</div>
<div class="row m-0 pt-3">
    <div class="col-xs-12">
        <addiko-mtoken-sign
            show-cancel="true"
            placeholder="qrChallenge ? 'signPayments.challengeDescriptionQR' : 'signPayments.challengeDescription'" 
            qr-challenge="qrChallenge" show-challenge="showChallenge" 
            challenge1="challengeFirstCode" challenge2="challengeSecondCode"></addiko-mtoken-sign>
    </div>
</div>
